var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"05ad5828bf0630260ae3a3c265e5de1ba59f5c0f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eth-dapp-v2@staderlabs"]={id:"05ad5828bf0630260ae3a3c265e5de1ba59f5c0f"};
      